<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Badges</mat-card-title>
        <mat-card-subtitle>
            Badges are icons that automatically get placed on assets with specific tags
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        @if (badges$ | async; as badges) {
            @if (badges.length > 0) {
                <mat-list>
                    @for (badge of badges; track badge) {
                        <mat-list-item>
                            <a matListItemTitle>{{ badge.tag.displayName }}</a>
                            <img matListItemIcon src="{{ badge.image }}" />
                        </mat-list-item>
                    }
                </mat-list>
            } @else {
                <p>There are no Badges, click Edit to add some</p>
            }
        }
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button color="primary" (click)="edit()">Edit</button>
    </mat-card-actions>
</mat-card>
